import { Injectable } from '@angular/core';
import { MapServiceService } from '../Map-service/map-service.service';

@Injectable({
  providedIn: 'root'
})
export class ScaleLineService {
  km: any
  ft: any
  kmPx: any
  ftPx: any
  constructor(public mapService: MapServiceService) {
    //
   }

  scaleLine(zoom: any) {
    this.km = '';
    this.ft = '';
    this.kmPx = '';
    this.ftPx = '';
    switch(zoom) {
      case 1:
        (this.km = '1000 km'),
        (this.ft = '200 mi'),
        (this.kmPx = '66px'),
        (this.ftPx = '53px');
        break;
      case 2:
        (this.km = '1000 km'),
        (this.ft = '200 mi'),
        (this.kmPx = '66px'),
        (this.ftPx = '53px');
        break;
      case 3:
        (this.km = '1000 km'),
        (this.ft = '200 mi'),
        (this.kmPx = '66px'),
        (this.ftPx = '53px');
        break;
        case 4:
          (this.km = '500 km'),
          (this.ft = '200 mi'),
          (this.kmPx = '65px'),
          (this.ftPx = '43px');
        break;
        case 5:
          (this.km = '200 km'),
          (this.ft = '100 mi'),
          (this.kmPx = '51px'),
          (this.ftPx = '41px');
        break;
        case 6:
          (this.km = '100 km'),
          (this.ft = '100 mi'),
          (this.kmPx = '51px'),
          (this.ftPx = '82px');
        break;
        case 7:
          (this.km = '50 km'),
          (this.ft = '50 mi'),
          (this.kmPx = '51px'),
          (this.ftPx = '82px');
        break;
        case 8:
          (this.km = '20 km'),
          (this.ft = '20 mi'),
          (this.kmPx = '39px'),
          (this.ftPx = '63px');
        break;
        case 9:
          (this.km = '10 km'),
          (this.ft = '10 mi'),
          (this.kmPx = '39px'),
          (this.ftPx = '63px');
        break;
        case 10:
          (this.km = '10 km'),
          (this.ft = '5 mi'),
          (this.kmPx = '79px'),
          (this.ftPx = '63px');
        break;
        case 11:
          (this.km = '5 km'), (this.ft = '2 mi');
          (this.kmPx = '79px'), (this.ftPx = '51px')
        break;
        case 12:
          (this.km = '2 km'),
          (this.ft = '1 mi'),
          (this.kmPx = '63px'),
          (this.ftPx = '51px');
        break;
        case 13:
          (this.km = '1000 m'),
          (this.ft = '2000 ft'),
          (this.kmPx = '63px'),
          (this.ftPx = '40px');
        break;
        case 14:
          (this.km = '500 m'),
          (this.ft = '1000 ft'),
          (this.kmPx = '63px'),
          (this.ftPx = '40px');
        break;
        case 15:
          (this.km = '200 m'),
          (this.ft = '1000 ft'),
          (this.kmPx = '50px'),
          (this.ftPx = '77px');
        break;
        case 16:
          (this.km = '100 m'),
          (this.ft = '500 ft'),
          (this.kmPx = '50px'),
          (this.ftPx = '77px');
        break;
        case 17:
          (this.km = '50 m'),
          (this.ft = '200 mi'),
          (this.kmPx = '50px'),
          (this.ftPx = '61px');
        break;
        case 18:
          (this.km = '20 m'),
          (this.ft = '100 ft'),
          (this.kmPx = '40px'),
          (this.ftPx = '61px');
        break;
        case 19:
          (this.km = '10 m'),
          (this.ft = '50 ft'),
          (this.kmPx = '40px'),
          (this.ftPx = '61px');
        break;
        case 20:
          (this.km = '10 m'), (this.ft = '20 ft');
          (this.kmPx = '81px'), (this.ftPx = '49px');
        break;
    }
  }
  zoomIn() {
    this.mapService.mapLayer
      ?.getView()
      .setZoom(this.mapService.mapLayer.getView().getZoom() + 1);
  }
  zoomOut() {
    this.mapService.mapLayer
      ?.getView()
      .setZoom(this.mapService.mapLayer.getView().getZoom() - 1);
  }
}
